// Drexel University's majors (#2739). Read on 2026-10-01 from the official
// Drexel University Catalog, Undergraduate Majors (catalog.drexel.edu/majors,
// updated August 2026), grouped by the college or school whose catalog pages
// hold each major, with the degree as the catalog writes it. The three names
// the A to Z list gives for the one General Business page (Business (General),
// Business Administration, General Business) are shown once, as the page names
// it. Left out: minors, certificates, accelerated degree programs (listed
// separately in the catalog), the undeclared and exploratory starting points
// (Business, Engineering, Science, General Humanities and Social Sciences,
// First Year Exploratory Studies), ROTC, the Chemistry Biochemistry
// concentration and the 3-year option of Entrepreneurship and Innovation.
// English is listed by its four concentrations, as the catalog lists it.
const majors = {
    "slug": "drexel-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Drexel's official undergraduate catalog, grouped by the college or school that offers it. Minors, certificates, accelerated degree programs and undeclared starting points are left out.",
    "groups": [
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "Drexel University Catalog, College of Arts & Sciences",
                "url": "https://catalog.drexel.edu/undergraduate/collegeofartsandsciences/"
            },
            "majors": [
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminology and Justice Studies",
                    "degree": "BS"
                },
                {
                    "name": "English, Creative Writing Concentration",
                    "degree": "BA"
                },
                {
                    "name": "English, Literary Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "English, Writing Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "English, Secondary Education Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies and Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Counseling",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Drexel University Catalog, School of Education",
                "url": "https://catalog.drexel.edu/undergraduate/schoolofeducation/"
            },
            "majors": [
                {
                    "name": "Educational Studies & Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Special Education (PK-12)",
                    "degree": "BS"
                },
                {
                    "name": "Teacher Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Nick Howley College of Engineering and Computing: School of Computer and Information Sciences",
            "source": {
                "label": "Drexel University Catalog, School of Computer and Information Sciences",
                "url": "https://catalog.drexel.edu/undergraduate/computer-information-sciences/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence & Machine Learning",
                    "degree": "BSAIML"
                },
                {
                    "name": "Computer Science",
                    "degree": "BACS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS"
                },
                {
                    "name": "Computing and Security Technology",
                    "degree": "BSCST"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Nick Howley College of Engineering and Computing: School of Engineering",
            "source": {
                "label": "Drexel University Catalog, School of Engineering",
                "url": "https://catalog.drexel.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Architectural Engineering",
                    "degree": "BSAE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCIV"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSENE"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSMSE"
                },
                {
                    "name": "Mechanical Engineering & Mechanics",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Nick Howley College of Engineering and Computing: School of Biomedical Engineering and Science",
            "source": {
                "label": "Drexel University Catalog, School of Biomedical Engineering and Science",
                "url": "https://catalog.drexel.edu/undergraduate/biomedical-engineering-science/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing and Health Professions",
            "source": {
                "label": "Drexel University Catalog, College of Nursing and Health Professions",
                "url": "https://catalog.drexel.edu/undergraduate/collegeofnursingandhealthprofessions/"
            },
            "majors": [
                {
                    "name": "Culinary Arts & Science",
                    "degree": "BSCAS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nutrition and Foods",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Dornsife School of Public Health",
            "source": {
                "label": "Drexel University Catalog, Dornsife School of Public Health",
                "url": "https://catalog.drexel.edu/undergraduate/schoolofpublichealth/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Goodwin College of Professional Studies",
            "source": {
                "label": "Drexel University Catalog, Goodwin College of Professional Studies",
                "url": "https://catalog.drexel.edu/undergraduate/collegeofprofessionalstudies/"
            },
            "majors": [
                {
                    "name": "Business Applications & Practice",
                    "degree": "BSIDPS"
                },
                {
                    "name": "Interdisciplinary Professional Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "LeBow College of Business",
            "source": {
                "label": "Drexel University Catalog, LeBow College of Business",
                "url": "https://catalog.drexel.edu/undergraduate/collegeofbusiness/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business and Engineering",
                    "degree": "BSBAE"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Law",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "General Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Health Services Administration",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Real Estate Management and Development",
                    "degree": "BSBA"
                },
                {
                    "name": "Sport Business",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "The Charles D. Close School of Entrepreneurship",
            "source": {
                "label": "Drexel University Catalog, The Charles D. Close School of Entrepreneurship",
                "url": "https://catalog.drexel.edu/undergraduate/schoolofentrepreneurship/"
            },
            "majors": [
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability and Innovation",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Economics",
            "source": {
                "label": "Drexel University Catalog, School of Economics",
                "url": "https://catalog.drexel.edu/undergraduate/schoolofeconomics/"
            },
            "majors": [
                {
                    "name": "Behavioral Economics, Business and Organizations",
                    "degree": "BS"
                },
                {
                    "name": "Economic Analysis",
                    "degree": "BAECON"
                },
                {
                    "name": "Economics",
                    "degree": "BSECON"
                },
                {
                    "name": "Economics and Business",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Data Science",
                    "degree": "BSECDS"
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Pennoni Honors College",
            "source": {
                "label": "Drexel University Catalog, Pennoni Honors College",
                "url": "https://catalog.drexel.edu/undergraduate/honorscollege/"
            },
            "majors": [
                {
                    "name": "Custom-Designed Major",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Thomas R. Kline School of Law",
            "source": {
                "label": "Drexel University Catalog, Thomas R. Kline School of Law",
                "url": "https://catalog.drexel.edu/undergraduate/schooloflaw/"
            },
            "majors": [
                {
                    "name": "Law",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Westphal College of Media Arts & Design",
            "source": {
                "label": "Drexel University Catalog, Westphal College of Media Arts & Design",
                "url": "https://catalog.drexel.edu/undergraduate/collegeofmediaartsanddesign/"
            },
            "majors": [
                {
                    "name": "Animation & Visual Effects",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BSCMGT"
                },
                {
                    "name": "Dance",
                    "degree": "BS"
                },
                {
                    "name": "Entertainment and Arts Management",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Industry & Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Film & Television",
                    "degree": "BS"
                },
                {
                    "name": "Game Design & Production",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Music Industry",
                    "degree": "BS"
                },
                {
                    "name": "Photography",
                    "degree": "BS"
                },
                {
                    "name": "Product Design",
                    "degree": "BS"
                },
                {
                    "name": "Screenwriting and Playwriting",
                    "degree": "BS"
                },
                {
                    "name": "User Experience and Interaction Design",
                    "degree": "BS"
                },
                {
                    "name": "Westphal Studies Program",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
